import React from "react";
import { Send } from "lucide-react";

interface FormFooterProps {
  onCancel: () => void;
  isLoading: boolean;
}

const FormFooter: React.FC<FormFooterProps> = ({
  onCancel,
  isLoading,
}) => (
  <div className="flex justify-end gap-3 pt-4 border-t border-slate-100">
    <button
      type="button"
      onClick={onCancel}
      disabled={isLoading}
      className="px-5 py-2 rounded-xl text-xs font-semibold text-slate-600
        bg-slate-50 border border-slate-200
        hover:bg-slate-100 transition-all duration-150
        disabled:opacity-50 disabled:cursor-not-allowed"
    >
      Annuler
    </button>

    <button
      type="submit"
      disabled={isLoading}
      className="flex items-center gap-2 px-5 py-2 rounded-xl text-xs font-bold text-white
        bg-[#0F52BA] hover:bg-blue-700 active:scale-[0.99]
        shadow-sm shadow-blue-200 transition-all duration-150
        disabled:opacity-60 disabled:cursor-not-allowed"
    >
      {isLoading ? (
        <>
          <div className="w-3.5 h-3.5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
          Envoi…
        </>
      ) : (
        <>
          <Send size={12} />
          Envoyer l'invitation
        </>
      )}
    </button>
  </div>
);

export default FormFooter;